import { SectionWrapper } from "@/components/core/section-wrapper";
import { Card } from "@/components/ui/card";
import type { LegalSection } from "@/types/site";

interface LegalShellProps {
  content: LegalSection;
}

export function LegalShell({ content }: LegalShellProps): JSX.Element {
  return (
    <SectionWrapper
      eyebrow="Legal shell"
      heading="Reusable information layout for policy and internal rules pages."
      intro={`Last updated ${content.updatedAt}. Use this shell for privacy, terms, operating standards, and client-facing legal content.`}
    >
      <div className="grid gap-5">
        {content.sections.map((section) => (
          <Card
            key={section.title}
            className="space-y-4"
          >
            <h2 className="text-xl font-bold">{section.title}</h2>
            <div className="space-y-3 text-muted-foreground">
              {section.body.map((paragraph) => (
                <p
                  key={paragraph}
                  className="leading-7"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </SectionWrapper>
  );
}
